import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosApiInstance from "app/services/axios";
import { DATASOURCE_CONFIG } from "app/config";
import {
  audiencePixelDataQuery,
  convertStringToInt,
  tabDataQuery,
} from "./reportingQueryUtill";
import {
  dataStoreRealTimeTable,
  eventHourlyReportingTable,
  getDataEndPoint,
  getReportingDataEndPoint,
} from "app/utils/constants/paths";
import moment from "moment";
import { REPORTING_INHOUSE_DSPS } from "app/utils/constants/configurations";
import cloneDeep from "lodash.clonedeep";
let tablePrefix = DATASOURCE_CONFIG.TABLE_PREFIX;

const initialState = {
  loading: false,
  tileLoading: false,
  reportingTabsData: {},
  tabLoaders: [],
};

const AudiencePixelAllReport = createSlice({
  name: "AudiencePixelAllReport",
  initialState,
  reducers: {
    updateTabLoaders(state, action) {
      state.tabLoaders.push(action.payload);
    },
    //   sortCreativesData(state, action) {
    //     let sortby = action.payload.sortby;
    //     let creativesData = cloneDeep(
    //       state.reportingTabsData?.creative_creative?.raw?.data
    //     );
    //     creativesData.sort((a, b) => b?.[sortby] - a?.[sortby]);
    //     state.reportingTabsData.creative_creative.raw.data = creativesData;
    //   },
    resetReportingData(state, action) {
      state.reportingTabsData = {};
      state.tabLoaders = [];
    },
  },

  extraReducers(builder) {
    builder
      .addCase(GetAudiencePixelAllReportingTabsDataThunk.pending, (state) => {
        state.dashboardPreInfoLoader = true;
      })
      .addCase(
        GetAudiencePixelAllReportingTabsDataThunk.fulfilled,
        (state, action) => {
          const dbResponse = action.payload.data.results;
          if (dbResponse && dbResponse.length) {
            let finalDataObj = dbResponse[0];
            // if (
            //   finalDataObj.length > 0 &&
            //   (action.meta.arg.tab == "creative_creative" ||
            //     action.meta.arg.tab == "campaign_day" ||
            //     action.meta.arg.tab == "campaign_dayofweek")
            // ) {
            //   for (let k = 0; k < finalDataObj.length; k++) {
            //     finalDataObj[k]["ctr"] =
            //       finalDataObj[k]["impressions"] == 0
            //         ? 0
            //         : Math.round(
            //             (finalDataObj[k]["clicks"] /
            //               finalDataObj[k]["impressions"]) *
            //               100 *
            //               100
            //           ) / 100;

            //     finalDataObj[k]["vcr"] =
            //       finalDataObj[k]["impressions"] == 0
            //         ? 0
            //         : Math.round(
            //             (finalDataObj[k]["complete"] /
            //               finalDataObj[k]["impressions"]) *
            //               100 *
            //               100
            //           ) / 100;
            //   }
            //   //finalDataObj = convertStringToInt(finalDataObj, []);
            // } else if (
            //   finalDataObj.length > 0 &&
            //   ((action.meta.arg.tab == "device_type" &&
            //     action.meta.arg.action == "ctr") ||
            //     (action.meta.arg.tab == "everything" &&
            //       action.meta.arg.action == "ctr") ||
            //     (action.meta.arg.tab == "device_os" &&
            //       action.meta.arg.action == "ctr") ||
            //     (action.meta.arg.tab == "campaign_daypart" &&
            //       action.meta.arg.action == "ctr"))
            // ) {
            //   for (let k = 0; k < finalDataObj.length; k++) {
            //     finalDataObj[k]["ctr"] =
            //       finalDataObj[k]["impressions"] == 0
            //         ? 0
            //         : Math.round(
            //             (finalDataObj[k]["clicks"] /
            //               finalDataObj[k]["impressions"]) *
            //               100 *
            //               100
            //           ) / 100;
            //   }
            //   finalDataObj.sort((a, b) => b?.["ctr"] - a?.["ctr"]);

            //   //If array contains more than 10 objects then take first 10 objects
            //   if (finalDataObj.length > 10) {
            //     finalDataObj = finalDataObj.slice(0, 10);
            //   }
            //   //finalDataObj = convertStringToInt(finalDataObj, []);
            // }
            finalDataObj = convertStringToInt(finalDataObj, []);

            if (state.reportingTabsData[action.meta.arg.tab]) {
              state.reportingTabsData[action.meta.arg.tab][
                action.meta.arg.action
              ] = {
                data: finalDataObj,
                updatedAt: moment().format("x"),
              };

              state.reportingTabsData[action.meta.arg.tab]["updatedAt"] =
                moment().format("x");
            } else {
              state.reportingTabsData[action.meta.arg.tab] = {};
              state.reportingTabsData[action.meta.arg.tab]["updatedAt"] =
                moment().format("x");

              state.reportingTabsData[action.meta.arg.tab][
                action.meta.arg.action
              ] = {
                data: finalDataObj,
                updatedAt: moment().format("x"),
              };
            }
            if (
              state.tabLoaders.indexOf(
                action.meta.arg.tab + "_" + action.meta.arg.action
              ) != -1
            ) {
              state.tabLoaders.splice(
                state.tabLoaders.indexOf(
                  action.meta.arg.tab + "_" + action.meta.arg.action
                ),
                1
              );
            }
          }
          state.tileLoading = false;
        }
      )
      .addCase(GetAudiencePixelAllReportingTabsDataThunk.rejected, (state) => {
        // state.dashboardPreInfoLoader = false;
      });
  },
});

export const GetAudiencePixelAllReportingTabsDataThunk = createAsyncThunk(
  "report/GetAudiencePixelAllReportingTabsDataThunk",
  async (payload) => {
    const queryBody = {
      queries: [
        {
          //Get Open Requests Query
          query: audiencePixelDataQuery(payload.tab, payload.action, payload),
          datasource: "mobiquity_redshift",
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(
        getReportingDataEndPoint,
        queryBody
      );
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

const { actions, reducer } = AudiencePixelAllReport;
export const { updateTabLoaders, resetReportingData } = actions;
export default reducer;
